import React, { type ReactNode } from 'react';
import { Flex, useScreenSize } from '@banhala/ui-kit';

export const ContentContainer: React.FC<{
  focused: boolean;
  children: ReactNode;
}> = props => {
  const { height: screenHeight } = useScreenSize();

  return <Flex minHeight={screenHeight}>{props.children}</Flex>;
};
